<template>
  <v-card class="card mx-auto w-100 mr-4 mr-md-0" outlined>
    <v-list-item three-line class="pa-0">
      <v-list-item-avatar
        tile
        size="65"
        class="mt-0 d-sm-none d-none d-md-flex mr-2 ml-0"
      >
        <v-img :alt="title" :src="image"></v-img>
      </v-list-item-avatar>
      <v-list-item-content class="pa-0">
        <v-card-text color="secondary" class="card__title pa-0 mt-xs-0">
          <v-img class="d-md-none" width="65" alt="" :src="image"></v-img>
          <p class="mt-3 mt-md-0 mb-1">{{ title }}</p>
        </v-card-text>
        <v-card-text class="card__description pa-0">
          {{ description }}
        </v-card-text>
        <v-card-actions class="card__actions py-0 pl-0">
          <component
            v-if="buttonText"
            :is="registerLinkTag"
            v-bind="registerLinkProps"
          >
            <v-btn
              class="card__btn rounded-0 mt-1 w-sm-100"
              depressed
              color="primary"
              height="23"
              width="97"
            >
              {{ buttonText }}
            </v-btn>
          </component>
          <button-download
            v-else
            :file="file"
            @on-download="handleClickDownload"
          />
        </v-card-actions>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import { SEGMENT_EVENTS } from '../../constants';
import ButtonDownload from '../buttons/button-download-1.vue';

export default {
  props: ['file', 'id', 'title', 'description', 'icon', 'buttonText'],
  components: {
    ButtonDownload,
  },
  data() {
    return {
      image: '',
    };
  },
  computed: {
    registerLinkTag() {
      const url = this.file || '';
      return url.startsWith('http') ? 'a' : 'router-link';
    },
    registerLinkProps() {
      const url = this.file || '';
      const isExternal = url.startsWith('http');
      return isExternal
        ? { href: url, target: '_blank' }
        : { to: url };
    },
  },
  created() {
    this.image = require('../../assets/list.svg');
  },
  methods: {
    handleClickDownload() {
      window.analytics.track(SEGMENT_EVENTS.DOWNLOAD_METHODOLOGY, {
        contentTitle: this.title,
        contentId: this.id,
        contentType: 'Methodology Quick Guides'
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: 0;
  border-left: 4px solid #029f48 !important;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  height: 100%;
  padding: 24px;
  cursor: text;
  @media (max-width: 1263px) {
    padding: 18px 22px;
  }
}
.card__actions {
  @media (max-width: 1263px) {
    padding: 0;
  }
}
.card .card__title {
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.1px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media (min-width: 960px) {
    height: 36px;
  }
  p {
    min-height: 36px;
  }
}
.card .card__description {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.1px;
  margin-bottom: 16px;
  color: #7b7d7a;
  display: -webkit-box;
  height: 88px;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: text;
  @media (min-width: 960px) {
    min-height: 51px;
  }

  @media (max-width: 959px) {
    margin-bottom: 0;
  }
}
.card .card__btn {
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  letter-spacing: 0.1px;
  text-transform: capitalize;
}
</style>
